// extracted by mini-css-extract-plugin
module.exports = {"deleteIcon":"styles_deleteIcon__3-VUn","shocksBlock":"styles_shocksBlock__2Y4qh","addButton":"styles_addButton__TOJ2O"};